import { IThunderboltEntry } from '@wix/editor-elements-types';

import {
  registerComponentTypeUiTypes,
  UiTypesRegistrationMap,
} from '../../registration/registration';

const UiTypes: UiTypesRegistrationMap = {
  '': () => [
    import('./viewer/CheckboxGroup' /* webpackChunkName: "CheckboxGroup" */),
    import(
      './viewer/CheckboxGroup.controller' /* webpackChunkName: "CheckboxGroup" */
    ),
  ],
};

const entry: IThunderboltEntry = {
  loadComponent: registerComponentTypeUiTypes('CheckboxGroup', UiTypes),
};

export default entry;
